function str2point(str) {
  const [lng, lat] = str.split(',').map(v => Number(v));
  return { lng, lat };
}

export function coordinates2points(coordinates) {
  return coordinates.split(' ').map(str2point);
}
